<script setup lang="ts">
interface Props {
  show: boolean
  title: string
  message: string
  confirmText?: string
  cancelText?: string
}

interface Emits {
  (e: 'confirm'): void
  (e: 'cancel'): void
}

const props = withDefaults(defineProps<Props>(), {
  confirmText: 'Confirm',
  cancelText: 'Cancel'
})

const emit = defineEmits<Emits>()

const handleConfirm = () => {
  emit('confirm')
}

const handleCancel = () => {
  emit('cancel')
}

// Close modal when clicking outside
const handleBackdropClick = (event: MouseEvent) => {
  if (event.target === event.currentTarget) {
    handleCancel()
  }
}
</script>

<template>
  <div
    v-if="show"
    class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
    @click="handleBackdropClick"
  >
    <div class="bg-gray-800 rounded-lg p-6 max-w-md mx-4 w-full shadow-xl">
      <h3 class="text-lg font-semibold text-white mb-4">{{ title }}</h3>
      <p class="text-gray-300 mb-6">{{ message }}</p>
      <div class="flex justify-end gap-4">
        <button
          @click="handleCancel"
          class="px-4 py-2 bg-gray-600 hover:bg-gray-700 text-white rounded-md font-medium transition duration-150"
        >
          {{ cancelText }}
        </button>
        <button
          @click="handleConfirm"
          class="px-4 py-2 bg-red-600 hover:bg-red-700 text-white rounded-md font-medium transition duration-150"
        >
          {{ confirmText }}
        </button>
      </div>
    </div>
  </div>
</template>
